import { render, staticRenderFns } from "./FileView.vue?vue&type=template&id=1240cc34&scoped=true&lang=pug"
import script from "./FileView.vue?vue&type=script&lang=ts"
export * from "./FileView.vue?vue&type=script&lang=ts"
import style0 from "./FileView.vue?vue&type=style&index=0&id=1240cc34&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1240cc34",
  null
  
)

export default component.exports